// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-notify-card__actions[data-v-ad53a680]{display:flex;flex-direction:column;grid-gap:16px;gap:16px}.modal-notify-card__actions>*[data-v-ad53a680]{border-radius:12px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
